const thumbsEl = document.querySelector('.thumbs-swiper');
const mainEl = document.querySelector('.main-swiper');
const DESKTOP_GALLERY_MQ = '(min-width: 1280px)';

function isDesktopGallery() {
  return window.matchMedia(DESKTOP_GALLERY_MQ).matches;
}

if (thumbsEl && mainEl) {
  const thumbsSwiper = new Swiper(thumbsEl, {
    spaceBetween: 8,
    slidesPerView: 'auto',
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    watchOverflow: true,
    freeMode: false,
    resistanceRatio: 0,
    breakpoints: {
      1280: { direction: 'vertical' },
    },

    mousewheel: {
      enabled: isDesktopGallery(),
      releaseOnEdges: false,
      forceToAxis: true,
      sensitivity: 1,
    },
  });

  const mainSwiper = new Swiper(mainEl, {
    spaceBetween: 10,

    // Going past the last image lands back on the first, for swipes as well as the
    // arrow and the tap-to-advance below: the gallery tells the product's story and
    // seeing the opener again "closes the box". Rewind is symmetric in Swiper, so
    // the backward wrap (first -> last) is blocked further down.
    rewind: true,

    zoom: {
      maxRatio: 3,
      // Tapping a slide advances the gallery (see the `click` handler below), so the
      // double-tap-to-zoom gesture has to go: its first tap would advance the slide out
      // from under the second. Pinch-to-zoom is unaffected.
      toggle: false,
    },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    thumbs: {
      swiper: thumbsSwiper,
    },
  });

  // Click/tap anywhere on the image advances to the next slide (`rewind` takes it
  // back to the first at the end). Swiper suppresses this event after a drag
  // (`preventClicks`), so a swipe never double-counts as a click.
  mainSwiper.on('click', (swiper, event) => {
    // The nav arrows live inside `.main-swiper`, so their own click bubbles here too —
    // without this the "next" arrow would skip two slides.
    if (event.target.closest('.swiper-button-next, .swiper-button-prev'))
      return;

    // The gift-open slide is a button that opens the video dialog
    // (assets/video-modal.js). Without this the tap would advance the gallery
    // out from under it and the film would never open.
    if (event.target.closest('[data-gallery-video-slide]')) return;

    // While pinch-zoomed, a tap is part of panning the zoomed image, not navigation.
    if (swiper.zoom && swiper.zoom.scale > 1) return;

    swiper.slideNext();
  });

  // The gallery only wraps forward. `rewind` would also jump first -> last on a
  // backward swipe or the prev arrow, so on the first slide block that direction
  // (a drag then holds still instead of rubber-banding) and grey the arrow out the
  // way Swiper's navigation does without rewind — it never disables either arrow
  // when `rewind` is on.
  const mainPrevButton = mainEl.querySelector('.swiper-button-prev');

  const lockBackwardWrap = (swiper) => {
    const atStart = swiper.isBeginning;

    swiper.allowSlidePrev = !atStart;

    if (mainPrevButton) {
      mainPrevButton.classList.toggle('swiper-button-disabled', atStart);
      mainPrevButton.setAttribute('aria-disabled', String(atStart));
    }
  };

  mainSwiper.on('toEdge fromEdge slideChange update', lockBackwardWrap);
  lockBackwardWrap(mainSwiper);

  mainSwiper.update();
  thumbsSwiper.update();

  const desktopGalleryMq = window.matchMedia(DESKTOP_GALLERY_MQ);

  desktopGalleryMq.addEventListener('change', (event) => {
    if (!thumbsSwiper.mousewheel) return;

    if (event.matches) thumbsSwiper.mousewheel.enable();
    else thumbsSwiper.mousewheel.disable();
  });

  const thumbsNext = document.querySelector('.thumbs-next');
  const thumbsPrev = document.querySelector('.thumbs-prev');

  if (thumbsNext)
    thumbsNext.addEventListener('click', () => {
      thumbsSwiper.slideNext();
    });

  if (thumbsPrev)
    thumbsPrev.addEventListener('click', () => {
      thumbsSwiper.slidePrev();
    });
}

class ProductCartHandler {
  constructor(form) {
    this.form = form;
    this.init();
  }

  init() {
    this.pairInput = this.form.querySelector('[data-pair-input]');
    this.cartUrl =
      (this.pairInput && this.pairInput.getAttribute('data-cart-url')) ||
      '/cart';
    this.submitting = false;
    this.busySubmitter = null;

    if (this.pairInput) this.pairInput.value = this.freshPair();

    // aria-busy survives the redirect to the cart on purpose (the pressed
    // color should hold until the cart paints), so a bfcache return is the
    // one path that has to take it back off.
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) this.setSubmitBusy(false);
    });
  }

  // Marks the submit button the shopper actually pressed for the aria-busy
  // styling hook. Tailwind v4 gates `hover:` behind `@media (hover: hover)`,
  // so on touch devices this is the only feedback a Tailwind-styled button
  // gives between the tap and the cart page.
  //
  // Scoped to the pressed button on purpose: the form has several submits
  // associated with it (main add-to-cart, the sticky bar, and the pay-later
  // button in blocks/product-payments.liquid via the `form` attribute), and
  // marking all of them made pressing "Add to cart" light up "Shop now, pay
  // later" as well, which reads as the two being wired together.
  setSubmitBusy(isBusy, submitter) {
    if (isBusy) {
      this.busySubmitter = this.resolveSubmitter(submitter);
      if (this.busySubmitter)
        this.busySubmitter.setAttribute('aria-busy', 'true');
      return;
    }

    // Clear across every submit, not just the remembered one: a bfcache
    // return restores the attribute from the HTML snapshot on whichever
    // button carried it, and `busySubmitter` does not survive the reload.
    this.busySubmitter = null;
    Array.from(this.form.elements).forEach((el) => {
      if (el.tagName === 'BUTTON' && el.type === 'submit')
        el.removeAttribute('aria-busy');
    });
  }

  // `event.submitter` is null when the form is submitted programmatically and
  // undefined on browsers that predate it — fall back to the focused submit,
  // then to the main add-to-cart button.
  resolveSubmitter(submitter) {
    const isFormSubmit = (el) =>
      el &&
      el.tagName === 'BUTTON' &&
      el.type === 'submit' &&
      el.form === this.form;

    if (isFormSubmit(submitter)) return submitter;
    if (isFormSubmit(document.activeElement)) return document.activeElement;

    return this.form.querySelector('.product__add-to-cart');
  }

  freshPair() {
    if (window.crypto && crypto.randomUUID)
      return crypto.randomUUID().slice(0, 12);

    return (
      'p' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8)
    );
  }

  getLinePair(line) {
    return line.properties && line.properties._pair;
  }

  buildLineResult(item, fallbackPair) {
    return {
      lineKey: item.key,
      pair: this.getLinePair(item) || fallbackPair,
      item,
    };
  }

  getSelectedVariantId() {
    const selected = this.form.querySelector('input[name="id"]:checked');
    if (selected) return parseInt(selected.value, 10);

    const fallback = this.form.querySelector('[name="id"]');
    return fallback ? parseInt(fallback.value, 10) : null;
  }

  async fetchCart() {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error('Failed to load cart');

    return response.json();
  }

  async addLine(variantId, pair, quantity = 1) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity,
        // Me unless the cart's gift sheet says otherwise: the backend reads a blank
        // delivery mode on an experience as RECIPIENT, and checkout would otherwise
        // write it gift by gift (GiftFormController.onCheckout in assets/cart.js).
        properties: { _pair: pair, _delivery_mode: 'SELF' },
      }),
    });

    if (!response.ok) throw new Error('Failed to add item to cart');

    const item = await response.json();
    return this.buildLineResult(item, pair);
  }

  // Every gift is its own cart line: adding a variant that is already in the cart
  // adds a second line under a fresh _pair instead of raising the first line's
  // quantity, so each gift can carry its own format, message and delivery (see
  // Cart.reconcileCompanions in assets/cart.js). No cart read is needed first.
  // When the buy block says Physical Gift Box, the box goes in with it.
  async addGift(variantId, options = {}) {
    const pair = options.pair || this.freshPair();
    if (this.pairInput) this.pairInput.value = pair;

    const boxId = this.selectedBoxVariantId();
    const added = boxId
      ? await this.addBoxedGift(variantId, boxId, pair)
      : await this.addLine(variantId, pair);
    // Every caller goes on to the cart page, so the A/B test's add event is sent from there.
    if (window.EwPdpTest) window.EwPdpTest.noteAdd();
    return added;
  }

  // The box variant when the buy block (snippets/gift-buy-block.liquid) is set to
  // Physical Gift Box, otherwise null. The block only carries the id while the box
  // can be bought.
  selectedBoxVariantId() {
    const block = document.querySelector('[data-buy-block]');
    if (!block || block.dataset.format !== 'box') return null;

    const id = parseInt(block.dataset.boxVariantId, 10);
    return isNaN(id) ? null : id;
  }

  // A boxed gift, exactly as the cart's own format choice writes one
  // (GiftFormats.write in assets/cart.js): the gift line, ONE box line on the same
  // _pair, and `_delivery_mode: SELF`, because a box ships to the checkout address.
  // /cart/add.js is all-or-nothing, so a box that sold out since the page rendered
  // fails the whole call — the gift then goes in alone, digital, rather than not at all.
  async addBoxedGift(variantId, boxId, pair) {
    const post = (items) =>
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });

    let response = await post([
      {
        id: variantId,
        quantity: 1,
        properties: { _pair: pair, _delivery_mode: 'SELF' },
      },
      { id: boxId, quantity: 1, properties: { _pair: pair } },
    ]);
    if (!response.ok)
      response = await post([
        {
          id: variantId,
          quantity: 1,
          properties: { _pair: pair, _delivery_mode: 'SELF' },
        },
      ]);
    if (!response.ok) throw new Error('Failed to add item to cart');

    const data = await response.json();
    const items = data.items || [];
    const item =
      items.find((line) => line.variant_id === variantId) || items[0];
    return this.buildLineResult(item, pair);
  }

  async removeLine(lineKey) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 }),
    });

    if (!response.ok) throw new Error('Failed to remove cart line');

    return response.json();
  }

  async swapLine(lineKey, newVariantId, { pair }) {
    const cart = await this.fetchCart();
    const existing = cart.items.find((line) => line.key === lineKey);

    if (!existing) throw new Error('Cart line not found');
    const added = await this.addLine(newVariantId, pair, existing.quantity);

    try {
      await this.removeLine(lineKey);
    } catch (error) {
      console.error(
        'ProductCartHandler: failed to remove old line after upgrade add',
        error,
      );
    }

    return added;
  }

  redirectToCart(options = {}) {
    if (options.replace) window.location.replace(this.cartUrl);
    else window.location.href = this.cartUrl;
  }

  bindEvents() {
    this.form.addEventListener('submit', (event) => this.handleSubmit(event));
  }

  async handleSubmit(event) {
    event.preventDefault();
    if (this.submitting) return;

    this.submitting = true;
    this.setSubmitBusy(true, event.submitter);
    let cartUpdated = false;

    try {
      const variantId = this.getSelectedVariantId();
      if (!variantId) throw 'No variant selected';

      await this.addGift(variantId);
      cartUpdated = true;
      this.redirectToCart();
    } catch (error) {
      console.error('ProductCartHandler: add to cart failed', error);
      if (!cartUpdated) this.form.submit();
    } finally {
      // Deliberately no setSubmitBusy(false): every exit navigates away
      // (redirect or native submit), and the pageshow handler clears it on a
      // bfcache return.
      this.submitting = false;
    }
  }
}

class UpSellModal {
  constructor(cart) {
    this.cart = cart;
    this.init();
  }

  init() {
    this.modal = document.getElementById('product-upsell-modal');
    this.closeButton = document.getElementById('product-close-button');
    this.form = this.cart.form;
    this.dataEl = document.getElementById('product-upsell-data');
    this.continueBtn = document.querySelector('[data-upsell-continue]');
    this.upgradeBtn = document.querySelector('[data-upsell-upgrade]');
    this.currentPanel = document.querySelector('[data-upsell-panel="current"]');
    this.upgradePanel = document.querySelector('[data-upsell-panel="upgrade"]');
    this.bestValueRibbon = document.querySelector('[data-upsell-best-value]');

    this.config = null;
    this.variants = [];
    this.saveLabelTemplate = '__PERCENT__%';
    this.lineKey = null;
    this.linePair = null;
    this.currentVariant = null;
    this.upgradeVariant = null;
    this.isBusy = false;
    this._redirectingToCart = false;
    this.upgradeErrorEl = null;

    if (!this.loadConfig()) {
      this.cart.bindEvents();
      return;
    }

    this.bindEvents();
  }

  loadConfig() {
    if (!this.modal || !this.dataEl) return false;

    try {
      this.config = JSON.parse(this.dataEl.textContent);
      this.variants = this.config.variants || [];
      this.saveLabelTemplate = this.config.saveLabelTemplate || '__PERCENT__%';
    } catch (error) {
      console.error('UpSellModal: failed to parse product upsell data', error);
      return false;
    }

    return this.config.enabled && this.variants.length > 0;
  }

  bindEvents() {
    if (this.closeButton)
      this.closeButton.addEventListener('click', () => this.closeModal());

    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal && !this.isBusy) this.closeModal();
    });

    this.modal.addEventListener('cancel', (e) => {
      if (this.isBusy) {
        e.preventDefault();
        return;
      }
      e.preventDefault();
      this.closeModal();
    });

    if (this.continueBtn)
      this.continueBtn.addEventListener('click', () => {
        if (this.isBusy) return;
        this.closeModal();
      });

    if (this.upgradeBtn)
      this.upgradeBtn.addEventListener('click', () => this.handleUpgrade());

    const formWrapper = document.getElementById('product-form');
    if (formWrapper && formWrapper.dataset.upsellEnabled === 'true')
      this.form.addEventListener('submit', (e) => this.handleSubmit(e));

    // closeModal() navigates to the cart without ever closing the dialog, so
    // the bfcache snapshot would hold the open modal and paint it for a frame
    // when the shopper navigates back. Close it in pagehide — the handler runs
    // before the page is frozen into bfcache, and nothing repaints on the way
    // out, so the snapshot lands on a clean PDP.
    window.addEventListener('pagehide', () => {
      if (this.modal?.open) this.modal.close();
    });

    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;

      this._redirectingToCart = false;
      this.isBusy = false;

      if (this.modal?.open) this.modal.close();
    });
  }

  openModal() {
    if (!this.modal || this.modal.open) return;
    this.modal.showModal();
    // The dialog itself, not the close button showModal() would pick: a phone rings it even
    // on a tap. Tab still reaches the button; Escape still closes.
    this.modal.focus({ preventScroll: true });
  }

  closeModal() {
    if (!this.modal || !this.modal.open || this._redirectingToCart) return;
    this._redirectingToCart = true;
    this.cart.redirectToCart();
  }

  getSelectedVariantId() {
    return this.cart.getSelectedVariantId();
  }

  showUpgradeError(message) {
    if (!this.upgradeBtn) return;

    if (!this.upgradeErrorEl) {
      this.upgradeErrorEl = document.createElement('p');
      this.upgradeErrorEl.className =
        'text-sm leading-[150%] text-center text-orange-4 mb-4 hidden';
      this.upgradeBtn.parentElement?.insertBefore(
        this.upgradeErrorEl,
        this.upgradeBtn,
      );
    }

    if (!this.upgradeErrorEl) return;

    this.upgradeErrorEl.textContent = message;
    this.upgradeErrorEl.classList.remove('hidden');
  }

  clearUpgradeError() {
    if (this.upgradeErrorEl) {
      this.upgradeErrorEl.textContent = '';
      this.upgradeErrorEl.classList.add('hidden');
    }
  }

  findVariantById(variantId) {
    return this.variants.find((v) => v.id === variantId) || null;
  }

  canFulfillQty(variant, qty) {
    if (!variant.available) return false;
    if (!variant.inventoryManagement) return true;
    if (variant.inventoryPolicy === 'continue') return true;

    return variant.inventoryQuantity >= qty;
  }

  findNextVariant(currentId, requiredQty = 1) {
    const current = this.findVariantById(currentId);
    if (!current) return null;

    const sorted = this.variants.slice().sort((a, b) => a.price - b.price);
    const currentIndex = sorted.findIndex((v) => v.id === currentId);
    if (currentIndex === -1) return null;

    for (let i = currentIndex + 1; i < sorted.length; i += 1) {
      if (
        sorted[i].price > current.price &&
        this.canFulfillQty(sorted[i], requiredQty)
      )
        return sorted[i];
    }

    return null;
  }

  isHeroOrCategoryLayer() {
    const layer = String(this.config.productLayer || '').toUpperCase();

    return layer === 'HERO' || layer === 'CATEGORY';
  }

  getPanelTitle(variant, role) {
    if (!variant) return '';

    if (this.isHeroOrCategoryLayer()) {
      if (role === 'upgrade')
        return this.config.upgradedGiftLabel || 'Upgraded gift';

      return this.config.productTitle || variant.displayName || variant.title;
    }

    return variant.displayName || variant.title;
  }

  setPanelContent(panel, variant, bulletsKey, role) {
    if (!panel || !variant) return;

    const titleEl = panel.querySelector('[data-upsell-title]');
    const priceEl = panel.querySelector('[data-upsell-price]');
    const compareEl = panel.querySelector('[data-upsell-compare-price]');
    const saveBadge = panel.querySelector('[data-upsell-save-badge]');
    const bulletsEl = panel.querySelector('[data-upsell-bullets]');

    if (titleEl) titleEl.textContent = this.getPanelTitle(variant, role);
    if (priceEl) priceEl.textContent = variant.priceFormatted;
    if (bulletsEl) bulletsEl.innerHTML = variant[bulletsKey] || '';

    const hasCompare =
      variant.compareAtPrice && variant.compareAtPrice > variant.price;

    if (compareEl) {
      if (hasCompare) {
        compareEl.textContent = variant.compareAtPriceFormatted;
        compareEl.classList.remove('hidden');
      } else {
        compareEl.textContent = '';
        compareEl.classList.add('hidden');
      }
    }

    if (saveBadge) {
      if (hasCompare && variant.savingsPercent > 0) {
        saveBadge.textContent = this.saveLabelTemplate.replace(
          '__PERCENT__',
          String(variant.savingsPercent),
        );
        saveBadge.classList.remove('hidden');
      } else {
        saveBadge.textContent = '';
        saveBadge.classList.add('hidden');
      }
    }
  }

  populateModal(current, upgrade) {
    this.setPanelContent(
      this.currentPanel,
      current,
      'bulletsModalHtml',
      'current',
    );
    this.setPanelContent(
      this.upgradePanel,
      upgrade,
      'bulletsUpgradeHtml',
      'upgrade',
    );

    if (this.bestValueRibbon) {
      if (upgrade && upgrade.badgeText)
        this.bestValueRibbon.textContent = upgrade.badgeText;
      this.bestValueRibbon.classList.remove('hidden');
    }
  }

  setBusy(isBusy, submitter) {
    this.isBusy = isBusy;
    [this.continueBtn, this.upgradeBtn, this.closeButton].forEach((btn) => {
      if (btn) btn.disabled = isBusy;
    });

    const addBtn =
      this.form && this.form.querySelector('.product__add-to-cart');
    if (addBtn) addBtn.disabled = isBusy;

    // Once we are navigating to the cart, keep aria-busy on the submit
    // buttons so their pressed color holds until the cart page paints —
    // the pageshow handler in ProductCartHandler clears it on a bfcache
    // return.
    if (isBusy || !this._redirectingToCart)
      this.cart.setSubmitBusy(isBusy, submitter);
  }

  dispatchAddedEvent(detail) {
    document.dispatchEvent(
      new CustomEvent('product:added-to-cart', { detail }),
    );
  }

  async handleSubmit(event) {
    event.preventDefault();
    if (this.isBusy) return;

    this.setBusy(true, event.submitter);
    let cartUpdated = false;

    try {
      const variantId = this.getSelectedVariantId();
      if (!variantId) {
        this.form.submit();
        return;
      }

      const current = this.findVariantById(variantId);

      const result = await this.cart.addGift(variantId);
      cartUpdated = true;

      const upgrade = this.findNextVariant(variantId, result.item.quantity);

      this.lineKey = result.lineKey;
      this.linePair = result.pair;
      this.currentVariant = current;
      this.upgradeVariant = upgrade;

      this.dispatchAddedEvent({
        variantId,
        lineKey: this.lineKey,
        item: result.item,
        upgradeAvailable: Boolean(upgrade),
      });

      if (!upgrade) {
        this._redirectingToCart = true;
        this.cart.redirectToCart();
        return;
      }

      this.clearUpgradeError();
      this.populateModal(current, upgrade);
      this.openModal();
    } catch (error) {
      console.error('UpSellModal: submit failed', error);
      if (!cartUpdated) this.form.submit();
    } finally {
      this.setBusy(false);
    }
  }

  async handleUpgrade() {
    if (this.isBusy || !this.lineKey || !this.upgradeVariant) return;

    if (!this.linePair) {
      this.showUpgradeError(
        'Something went wrong upgrading your gift. Please try again or continue with your current selection.',
      );
      return;
    }

    this.setBusy(true);
    this.clearUpgradeError();

    try {
      await this.cart.swapLine(this.lineKey, this.upgradeVariant.id, {
        pair: this.linePair,
      });
      this.closeModal();
    } catch (error) {
      console.error('UpSellModal: upgrade failed', error);
      this.showUpgradeError(
        'Something went wrong upgrading your gift. Please try again or continue with your current selection.',
      );
    } finally {
      this.setBusy(false);
    }
  }
}

// Document-scoped and every match, not the first one inside #product-form: the mobile
// sticky buy bar renders a second [data-add-to-cart-price] outside that wrapper, and it
// would otherwise keep showing the price the shopper started on.
function updateAddToCartPrice(input) {
  // Every option carries data-variant-price on the label wrapping its radio.
  const source = input.closest('[data-variant-price]');
  if (!source) return;

  // The buy block's options carry a total per format (gift, or gift + box), so the
  // button, the sticky bar and the card all quote what the cart will charge.
  if (source.dataset.totalDigital !== undefined) {
    updateBuyBlockPrices(source);
    return;
  }

  const priceEls = document.querySelectorAll('[data-add-to-cart-price]');
  if (!priceEls.length) return;

  priceEls.forEach((priceEl) => {
    priceEl.textContent = source.dataset.variantPrice;
  });

  // The compare-at price and the save badge were server-rendered once, from the
  // preselected variant, and never touched again. That was harmless while the gift
  // card was the only product with a live choice — its amounts carry no compare-at
  // price at all — but every option on a gift-option-picker product has its own
  // (145 / 215 / 305 / 420 on a city page), so a stale pair misprices the discount.
  const compareAtPrice = source.dataset.variantCompareAtPrice || '';
  const saveEl = input
    .closest('label')
    ?.querySelector('[data-variant-save-text]');
  const saveText = saveEl ? saveEl.textContent.trim() : '';

  document
    .querySelectorAll('[data-add-to-cart-compare-price]')
    .forEach((el) => {
      el.textContent = compareAtPrice;
    });

  document.querySelectorAll('[data-add-to-cart-save]').forEach((el) => {
    el.textContent = saveText;
  });

  // One toggle for the pair: a compare-at price with no saving to quote, or the
  // reverse, would read as a broken row rather than a discount.
  const hasDiscount = Boolean(compareAtPrice && saveText);
  document.querySelectorAll('[data-add-to-cart-discount]').forEach((el) => {
    el.classList.toggle('hidden', !hasDiscount);
  });
}

// Writes the chosen option's total for the chosen format everywhere a price is quoted:
// the "What's included" card, Add to cart and the mobile sticky bar. Every figure was
// rendered by Liquid (snippets/gift-buy-block.liquid), so nothing is formatted here.
function updateBuyBlockPrices(source) {
  const block = document.querySelector('[data-buy-block]');
  const box = block && block.dataset.format === 'box';
  const total = box ? source.dataset.totalBox : source.dataset.totalDigital;
  const compareAt = box
    ? source.dataset.compareBox
    : source.dataset.compareDigital;
  const save = box ? source.dataset.saveBox : source.dataset.saveDigital;
  // One toggle for the pair: a compare-at price with no saving to quote, or the
  // reverse, would read as a broken row rather than a discount.
  const hasDiscount = Boolean(compareAt && save);

  const write = (selector, text) => {
    document.querySelectorAll(selector).forEach((el) => {
      el.textContent = text;
    });
  };

  write('[data-add-to-cart-price], [data-buy-total]', total);
  write('[data-add-to-cart-compare-price], [data-buy-compare]', compareAt);
  write('[data-add-to-cart-save], [data-buy-save]', save);

  document.querySelectorAll('[data-add-to-cart-discount]').forEach((el) => {
    el.classList.toggle('hidden', !hasDiscount);
  });
  document
    .querySelectorAll('[data-buy-compare], [data-buy-save]')
    .forEach((el) => {
      el.hidden = !hasDiscount;
    });
}

// Every option's bullets are in the markup already (snippets/gift-option-picker.liquid
// renders one wrapper per variant); this reveals the selected one. No fetch, no
// template, and the panel is correct before this ever runs.
function swapGiftOptionBullets(input) {
  const panels = document.querySelectorAll('[data-gift-option-bullets-for]');
  if (!panels.length) return;

  panels.forEach((panel) => {
    panel.toggleAttribute(
      'hidden',
      panel.dataset.giftOptionBulletsFor !== input.value,
    );
  });
}

function initVariantChangeHandler() {
  const form = document.getElementById('product-form');
  if (!form) return;

  form.addEventListener('change', (event) => {
    const input = event.target.closest('input[name="id"]');
    if (!input) return;

    updateAddToCartPrice(input);
    swapGiftOptionBullets(input);

    const label = input.closest('[data-variant-sku]');
    if (!label) return;

    const detail = {
      variantId: Number(label.dataset.variantId),
      sku: label.dataset.variantSku,
    };

    document.dispatchEvent(
      new CustomEvent('everwow:variantchanged', { detail }),
    );
  });
}

function initProductCart() {
  const formWrapper = document.getElementById('product-form');
  const form = formWrapper?.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  const cart = new ProductCartHandler(form);
  // Shared with the experience-details modal: its "Gift this collection" CTA
  // adds the selected variant through this handler (which owns the `_pair`
  // property and the cart URL) and goes straight to the cart.
  window.EverwowProductCart = cart;
  const upsellEnabled =
    formWrapper?.dataset.upsellEnabled === 'true' &&
    document.getElementById('product-upsell-modal');

  if (upsellEnabled) new UpSellModal(cart);
  else cart.bindEvents();
}

/**
 * Sticky buy bar (snippets/sticky-add-to-cart.liquid).
 *
 * Shown once the real Add to cart has been scrolled past, i.e. while it sits
 * above the screen; not on landing, while it is still below the fold, so the
 * opening screen has one buy button, not two. Taken away again over the
 * footer, the one place it would cover links people are trying to reach.
 *
 * No breakpoint check here: the bar is `xl:hidden`, so from 1280px, where the
 * page goes two-column, it is `display: none` and the observers toggle
 * attributes nothing reads.
 */
function initStickyAddToCart() {
  const bar = document.querySelector('[data-sticky-atc]');
  const formWrapper = document.getElementById('product-form');
  if (!bar || !formWrapper) return;
  const button =
    formWrapper.querySelector('.product__add-to-cart') || formWrapper;

  // sections/footer.liquid has no <footer> tag and no stable class; its outer
  // div is the only thing carrying an id, as `footer-<section id>`.
  const footer = document.querySelector('[id^="footer-"]');

  let buttonPassed = false;
  let footerOnScreen = false;

  const apply = () => {
    const show = buttonPassed && !footerOnScreen;
    bar.toggleAttribute('data-visible', show);
    // The bar stays in the layout while hidden, translated below the viewport,
    // so `inert` is what keeps its button out of the tab order.
    bar.inert = !show;
    bar.setAttribute('aria-hidden', String(!show));
  };

  const watch = (target, assign, options) => {
    const observer = new IntersectionObserver((entries) => {
      assign(entries[entries.length - 1].isIntersecting);
      apply();
    }, options);
    observer.observe(target);
  };

  // The root is the screen stretched far down, so the button leaves it only by
  // going above the screen, and is back in however it returns: a jump from the
  // footer to the top never puts it on screen, so the plain screen would miss it.
  watch(
    button,
    (reachable) => {
      buttonPassed = !reachable;
    },
    { rootMargin: '0px 0px 100000px 0px' },
  );

  if (footer)
    watch(footer, (onScreen) => {
      footerOnScreen = onScreen;
    });

  apply();
}

/**
 * The "See included experiences" strip ships visible so it cannot shift the page
 * when the experiences API answers (snippets/experiences-strip.liquid). Its own
 * section retracts it for a SKU with nothing to open — but not on a product
 * template edited in the theme editor to drop that section, where
 * product-explore-experiences-map.js never loads and nothing decides at all.
 * This file loads on every product page, so it can.
 */
function initExperiencesStripFallback() {
  if (document.querySelector('.explore_experiences')) return;

  document
    .querySelectorAll('[data-experiences-jump], [data-experiences-scroll]')
    .forEach((button) => {
      button.removeAttribute('data-experiences-jump-ready');
    });
}

/**
 * The buy block (snippets/gift-buy-block.liquid): slides each bar's thumb to its
 * chosen option, switches everything that depends on the format — the detail line,
 * the card's format row, "Box included", delivery strip S2 and every quoted price —
 * and opens the two preview sheets, whose button picks that format.
 *
 * The state lives in the radios. It is read back from them on load and on a bfcache
 * return, because the browser restores a checked radio without firing `change`.
 */
function initBuyBlock() {
  const block = document.querySelector('[data-buy-block]');
  if (!block) return;

  const selectedVariantInput = () =>
    block.querySelector('input[name="id"]:checked') ||
    block.querySelector('input[name="id"]');

  const slideThumb = (bar) => {
    const radios = Array.from(bar.querySelectorAll('input[type="radio"]'));
    const index = radios.findIndex((radio) => radio.checked);
    if (index >= 0) bar.style.setProperty('--sel', index);
  };

  const applyFormat = () => {
    const checked = block.querySelector('input[name="gift_format"]:checked');
    const format = checked ? checked.value : 'digital';
    block.dataset.format = format;

    document.querySelectorAll('[data-format-show]').forEach((el) => {
      el.hidden = el.dataset.formatShow !== format;
    });

    const variantInput = selectedVariantInput();
    if (variantInput) updateAddToCartPrice(variantInput);
    document.dispatchEvent(
      new CustomEvent('everwow:formatchanged', { detail: { format } }),
    );
  };

  const sync = () => {
    block.querySelectorAll('[data-buy-bar]').forEach(slideThumb);
    const variantInput = selectedVariantInput();
    if (variantInput && variantInput.type === 'radio')
      swapGiftOptionBullets(variantInput);
    applyFormat();
  };

  block.addEventListener('change', (event) => {
    const bar = event.target.closest('[data-buy-bar]');
    if (bar) slideThumb(bar);
    // A variant change reprices through initVariantChangeHandler, which reads
    // the format this block holds.
    if (event.target.name === 'gift_format') applyFormat();
  });

  const pick = (format) => {
    const radio = block.querySelector(
      `input[name="gift_format"][value="${format}"]`,
    );
    if (!radio || radio.disabled || radio.checked) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  };

  block.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-buy-sheet-open]');
    if (opener) {
      const sheet = block.querySelector(
        `[data-buy-sheet="${opener.dataset.buySheetOpen}"]`,
      );
      if (sheet && !sheet.open) sheet.showModal();
      return;
    }

    const sheet = event.target.closest('[data-buy-sheet]');
    if (!sheet) return;

    const picker = event.target.closest('[data-buy-sheet-pick]');
    // A click on the dialog itself is a click on its backdrop: the panel fills
    // the rest of the box.
    if (
      picker ||
      event.target === sheet ||
      event.target.closest('[data-buy-sheet-close]')
    ) {
      if (picker) pick(picker.dataset.buySheetPick);
      sheet.close();
    }
  });

  sync();
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) sync();
  });
}

/**
 * Delivery strip S2's box state (snippets/delivery-strip.liquid), in Chicago time:
 *
 * - The countdown runs to the next 1:00 AM or 1:00 PM, every day; neither time is shown.
 * - The receive date counts only the real cutoff, 1:00 PM on a weekday: before it the
 *   order day is today, otherwise the next weekday; then 1 weekday to process and 2 to
 *   ship, weekends skipped. There is no holiday calendar.
 *
 * It only ticks while the box state is on screen.
 */
function initDeliveryStrip() {
  const strip = document.querySelector('[data-delivery-countdown]');
  if (!strip) return;

  const TIME_ZONE = 'America/Chicago';
  const COUNTDOWN_HOURS = [1, 13];
  const CUTOFF_HOUR = 13;
  const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const locale = document.documentElement.lang || 'en';

  const chicago = new Intl.DateTimeFormat('en-US', {
    timeZone: TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
    weekday: 'short',
  });
  const monthName = new Intl.DateTimeFormat(locale, {
    month: 'short',
    timeZone: 'UTC',
  });
  const dayName = new Intl.DateTimeFormat(locale, {
    weekday: 'long',
    timeZone: 'UTC',
  });

  const partsAt = (ms) => {
    const parts = {};
    chicago.formatToParts(new Date(ms)).forEach((part) => {
      parts[part.type] = part.value;
    });
    return {
      year: +parts.year,
      month: +parts.month,
      day: +parts.day,
      hour: +parts.hour % 24,
      minute: +parts.minute,
      second: +parts.second,
      weekday: WEEKDAYS.indexOf(parts.weekday),
    };
  };

  // Chicago's UTC offset at an instant, then its wall clock back to an instant —
  // looked up twice, so a daylight-saving change in between is handled.
  const offsetAt = (ms) => {
    const p = partsAt(ms);
    return (
      Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) -
      Math.floor(ms / 1000) * 1000
    );
  };
  const wallClockToMs = (year, month, day, hour) => {
    const wall = Date.UTC(year, month - 1, day, hour);
    return wall - offsetAt(wall - offsetAt(wall));
  };

  const nextCountdownEnd = (ms) => {
    const p = partsAt(ms);
    for (let i = 0; i < 3; i++) {
      const date = new Date(Date.UTC(p.year, p.month - 1, p.day + i));
      for (const hour of COUNTDOWN_HOURS) {
        const end = wallClockToMs(
          date.getUTCFullYear(),
          date.getUTCMonth() + 1,
          date.getUTCDate(),
          hour,
        );
        if (end > ms) return end;
      }
    }
    return ms;
  };

  const pad = (n) => String(n).padStart(2, '0');
  const countdownText = (ms) => {
    const secs = Math.max(0, Math.ceil((nextCountdownEnd(ms) - ms) / 1000));
    return `${pad(Math.floor(secs / 3600))} : ${pad(
      Math.floor((secs % 3600) / 60),
    )} : ${pad(secs % 60)}`;
  };

  const addWeekdays = (date, count) => {
    let result = date;
    let left = count;
    while (left > 0) {
      result = new Date(result.getTime() + 864e5);
      const day = result.getUTCDay();
      if (day > 0 && day < 6) left--;
    }
    return result;
  };

  const receiveDate = (ms) => {
    const p = partsAt(ms);
    const today = new Date(Date.UTC(p.year, p.month - 1, p.day));
    const beforeCutoff = p.weekday > 0 && p.weekday < 6 && p.hour < CUTOFF_HOUR;
    const orderDay = beforeCutoff ? today : addWeekdays(today, 1);
    return addWeekdays(orderDay, 3);
  };

  const countdownEl = strip.querySelector('[data-countdown]');
  const dateEl = strip.querySelector('[data-receive-date]');
  const dayEl = strip.querySelector('[data-receive-day]');
  const setText = (el, text) => {
    if (el && el.textContent !== text) el.textContent = text;
  };

  const tick = () => {
    const now = Date.now();
    const date = receiveDate(now);
    setText(countdownEl, countdownText(now));
    setText(
      dateEl,
      `${monthName
        .format(date)
        .toUpperCase()} ${date.getUTCDate()}, ${date.getUTCFullYear()}`,
    );
    setText(dayEl, dayName.format(date));
  };

  let timer = null;
  const update = () => {
    if (strip.hidden) {
      clearInterval(timer);
      timer = null;
      return;
    }
    tick();
    if (!timer) timer = setInterval(tick, 250);
  };

  document.addEventListener('everwow:formatchanged', update);
  update();
}

function initPage() {
  initVariantChangeHandler();
  initProductCart();
  initStickyAddToCart();
  initExperiencesStripFallback();
  initDeliveryStrip();
  initBuyBlock();
}

if (document.readyState === 'loading')
  document.addEventListener('DOMContentLoaded', initPage);
else initPage();
